import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialFlipVerticalUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.43 16.76h1.52v13.71h1.52V16.76H32v-1.52h-4.57zm1.52-15.24h1.52v4.57h-1.52Zm0 7.62h1.52v4.57h-1.52Z\"/><path fill=\"currentColor\" d=\"M3.05 30.47h25.9V32H3.05ZM24.38 0h4.57v1.52h-4.57Zm-1.53 15.24h3.05v1.52h-3.05Zm-1.52 4.57V9.14H10.66v1.52h1.53v1.53h1.52v1.52h-1.52v1.53h-1.53v4.57h1.53v3.04h1.52v1.53h6.1v-1.53h-3.05v-1.52h-1.52v-3.05h1.52v-1.52h1.52v1.52h1.53v1.53zM16.76 0h4.57v1.52h-4.57Zm-6.1 0h4.58v1.52h-4.58ZM6.09 15.24h3.05v1.52H6.09ZM3.05 0h4.57v1.52H3.05ZM1.52 1.52h1.53v4.57H1.52Zm0 7.62h1.53v4.57H1.52Z\"/><path fill=\"currentColor\" d=\"M4.57 16.76v-1.52H0v1.52h1.52v13.71h1.53V16.76z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialFlipVerticalUp
